import Configuration from '../../../../config/Configuration';
import Component from '../../../component/Component';
import React from 'react';

export class CookiesWarning extends Component {
  private linkId: string = 'cookiesettings';
  /**
   * Handle link clicks, prevent link opening and copy link URL to Clipboard
   * @param e
   */
  handleClick = (e) => {
    e.preventDefault();
    if (e.target.id === this.linkId) {
      // Create document select range object
      let selection: Selection = document.getSelection();
      if (selection && selection.removeAllRanges) {
        selection.removeAllRanges();
      }
      let range = document.createRange();
      range.selectNode(e.target);
      selection.addRange(range);

      try {
        // Now that we've selected the anchor text, execute the copy command
        document.execCommand('copy');
        selection.removeRange(range);
      } catch (err) {
        selection.removeAllRanges();
      }
    }
  };

  render() {
    return (
      <div>
        <div
          className='k-hbox k-align-items-center tp-font-size-lg'
        >
          <i
            aria-hidden="true"
            className="tp-icon tp-warning-triangle tp-icon-l tp-color-yellow-500"
          />
          <span
            className='tp-text-semibold tp-text-semibold tp-font-size-md tp-space-left-1'
          >{this.translate('subTitle')}</span>
        </div>

        <div
          aria-live={'polite'}
          aria-hidden={'true'}
          role={'alert'}
          onClick={(e => this.handleClick(e))}
        >
          {this.translate('text', {
            linkId: this.linkId,
            chromeSettingsLink: 'chrome://settings/cookies',
            ssoUrl: Configuration.get().AUTH.authority
          })}
        </div>
      </div>
    );
  }
}
